export default __webpack_public_path__ + "static/media/Card.e2ffb158.svg";